import styled from "styled-components";

/* Fixed 1920x1080 Canvas */
export const ScreenWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
`;

/* Title */
export const Title = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  width: 60.3125rem;
  text-align: center;
`;

/* Highlight Message Box */
export const MessageBox = styled.div`
  margin-top: 1.5rem;
  font-size: 1.75rem;
  text-align: center;
  font-weight: 400;
`;

/* CTA Button */
export const ActionButton = styled.button`
  margin-top: 3rem;
  width: 26rem;
  height: 4rem;
  font-size: 1.75rem;
  font-weight: 700;
  background-color: #d9d9d9;
  border: none;
  border-radius: 0.4rem;
  cursor: pointer;
`;
